import { type Message } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

export function getScheduleRovoChatRuleIdUuidFromExecutionMessage(
	message: Message,
): string | undefined {
	const raw = message.message_metadata?.ruleIdUuid;
	if (raw === undefined || raw === null) {
		return undefined;
	}
	const s = typeof raw === 'string' ? raw.trim() : String(raw);
	return s.length > 0 ? s : undefined;
}
